import React, { useId } from 'react';
import IProps from './interface';

const DYNAMICS_MARK_PATH =
  'M0 3.24301C0 0.556995 1.79738 -0.11517 3.75053 0.0153116C17.6097 0.941235 30 5.04795 30 10.3228V26.5735C30 24.051 27.4524 21.9417 23.5047 20.2893C22.9058 20.0386 22.5014 19.4607 22.5014 18.8115V13.5044C22.5014 10.4674 21.2274 9.1941 18.7515 8.48636C16.2755 7.77863 14.9984 8.56286 14.9984 11.3524V14.0135C14.9984 15.8832 13.779 17.1139 11.6291 17.465C9.4791 17.8161 7.65405 18.0245 4.87781 18.2755C2.10154 18.5265 0 16.7421 0 13.7213V3.24301Z';

const DYNAMICS_FRONT_PATH =
  'M29.9996 10.3236C29.9996 14.6488 22.0596 18.012 11.9996 19.6721C9.46772 20.0899 7.49961 21.2743 7.49961 23.9176V31.9892C7.49961 35.8174 9.80346 36.3215 12.7488 35.8174C23.3225 34.0077 29.9996 30.2903 29.9996 26.5608V10.3236Z';

const CrmDynamicsIcon = ({
  className,
  onClick,
  viewBox = '-3 0 36 36',
}: IProps) => {
  // Gradient ids are document-wide, and the icon renders many times per page.
  const id = useId();

  return (
    <svg
      width="16"
      height="16"
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path d={DYNAMICS_MARK_PATH} fill={`url(#${id}-a)`} />
      <path d={DYNAMICS_MARK_PATH} fill={`url(#${id}-b)`} />
      <path d={DYNAMICS_MARK_PATH} fill={`url(#${id}-c)`} />
      <path d={DYNAMICS_FRONT_PATH} fill={`url(#${id}-d)`} />
      <path d={DYNAMICS_FRONT_PATH} fill={`url(#${id}-e)`} fillOpacity="0.5" />
      <path
        opacity="0.5"
        d="M22.4998 23.3834C22.4997 26.5269 21.4013 27.6403 18.7512 28.3957C16.4362 29.0556 14.9998 28.802 14.9998 25.5283V19.1108C17.7754 18.5309 20.3228 17.8145 22.4998 16.9787V23.3834Z"
        fill={`url(#${id}-f)`}
      />
      <defs>
        <linearGradient
          id={`${id}-a`}
          x1="3.79999"
          y1="0.793238"
          x2="14.6935"
          y2="22.8582"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#367AF2" />
          <stop offset="0.28721" stopColor="#2764E7" />
          <stop offset="0.660233" stopColor="#4A43CB" />
          <stop offset="1" stopColor="#6D37CD" />
        </linearGradient>
        <radialGradient
          id={`${id}-b`}
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(6.62276 19.629 -44.6576 15.3169 11.9772 0.598576)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.619721" stopColor="#5750E2" stopOpacity="0" />
          <stop offset="1" stopColor="#4B20A0" />
        </radialGradient>
        <radialGradient
          id={`${id}-c`}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.4375 19.0078) rotate(-90) scale(20.0133 35.898)"
        >
          <stop offset="0.55" stopColor="#2764E7" stopOpacity="0" />
          <stop offset="1" stopColor="#AC80FF" />
        </radialGradient>
        <linearGradient
          id={`${id}-d`}
          x1="22.3022"
          y1="34.8649"
          x2="22.3022"
          y2="13.8561"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2052CB" />
          <stop offset="0.40599" stopColor="#2764E7" />
          <stop offset="1" stopColor="#BD96FF" />
        </linearGradient>
        <linearGradient
          id={`${id}-e`}
          x1="24.4733"
          y1="18.69"
          x2="29.9996"
          y2="18.69"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#367AF2" stopOpacity="0" />
          <stop offset="0.488848" stopColor="#4BA3F3" stopOpacity="0.3769" />
          <stop offset="1" stopColor="#6FE8F5" />
        </linearGradient>
        <linearGradient
          id={`${id}-f`}
          x1="18.6294"
          y1="17.0535"
          x2="18.6294"
          y2="27.8019"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CEB0FF" />
          <stop offset="1" stopColor="#4894FE" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CrmDynamicsIcon;
